import styled from "styled-components";

export const InputWrapper = styled.div`
  .container {
    width: fit-content;
    height: fit-content;
    gap: 16px;
  }

  .character {
    width: 48px;
    height: 48px;

    font-size: 2.25rem;
    line-height: 130%;
    font-family: "Kantumruy Pro";
    font-weight: 300;

    border-radius: 8px;

    background: rgba(235, 194, 142, 0.06);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);

    color: #ffffff;

    border: 1px solid rgba(235, 194, 142, 0.25);
    transition: all 0.2s ease;
  }

  .character-selected {
    border-color: rgba(235, 194, 142, 0.5);
    background: rgba(235, 194, 142, 0.1);
    box-shadow: 0 0 12px rgba(186, 144, 92, 0.15);

    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    &::before {
      content: "";
      display: block;
      height: 65%;
      width: 1px;
      background: #fff;
      animation: blink 1.25s infinite steps(1, start);
    }

    @keyframes blink {
      0%,
      70% {
        opacity: 1;
      }
      71%,
      100% {
        opacity: 0;
      }
    }
  }

  @media only screen and (max-width: 400px) {
    .character {
      width: 44px;
      height: fit-content;
      aspect-ratio: 1 / 1;
      font-size: 2rem;
    }
    .container {
      gap: 8px;
    }
  }
`;
